import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { PopupDecorator } from '../PopupDecorator/PopupDecorator';

import './PredictorId.css';
import * as keyset from './PredictorId.i18n';

const i18n = i18nFactory(keyset);

export interface PredictorIdProps {
    id?: string;
}

const BLOCK = 'predictor-id';

export const PredictorId = React.memo(function({ id }: PredictorIdProps) {
    const [isPopupVisible, setPopupVisibleState] = React.useState(false);
    const [anchor, setAnchorState] = React.useState<React.ReactNode | null>(null);

    const onChangeStatusPopup = () => setPopupVisibleState(!isPopupVisible);

    return (
        <div className={Bem.cls(BLOCK)}>
            <div
                ref={ref => (setAnchorState(ref), ref)}
                onClick={onChangeStatusPopup}
                className={Bem.cls(BLOCK, 'hint')}
            >
                ID
            </div>
            <PopupDecorator
                cls={Bem.cls(BLOCK, 'popup')}
                onClose={onChangeStatusPopup}
                target={'anchor'}
                anchor={anchor}
                directions={['bottom-center']}
                visible={isPopupVisible}
                hasTail={true}
                onOutsideClick={onChangeStatusPopup}
            >
                {id ? <div>{i18n('id-predictor', { id })}</div> : null}
            </PopupDecorator>
        </div>
    );
});
